(function () {
  if (window.__bvPdp) return;
  window.__bvPdp = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Where "Größe wählen" should land: the Kaching offer box, else the product form */
  var BUY_SELECTORS = [
    '.product__info-container [data-bv-buybox]',
    '.product__info-container [class*="kaching"]',
    '.product__info-container [id*="kaching"]',
    '.product__info-container kaching-bundles',
    '.product__info-container .product-form__input',
    '.product__info-container variant-selects',
    '.product__info-container product-form',
    '.product__info-container .product-form',
    '#bv-buy-anchor',
    '.product__info-container'
  ];

  function buyTarget() {
    for (var i = 0; i < BUY_SELECTORS.length; i++) {
      var el = document.querySelector(BUY_SELECTORS[i]);
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bv-scroll-buy]');
    if (!trigger) return;
    e.preventDefault();
    var target = buyTarget();
    if (!target) { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
    var header = document.querySelector('.section-header');
    var offset = header ? header.getBoundingClientRect().height + 12 : 12;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    /* give the buy box a short highlight so it is obvious where you landed */
    target.classList.add('bv-flash');
    setTimeout(function () { target.classList.remove('bv-flash'); }, 1200);
  });

  /* Delivery estimate: counts business days (Mon–Fri) */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function renderDelivery() {
    document.querySelectorAll('[data-bv-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max'), 10) || min;
      var locale = el.getAttribute('data-locale') || 'de-DE';
      var fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'long' });
      var now = new Date();
      var out = el.querySelector('[data-bv-delivery-dates]');
      if (out) out.textContent = fmt.format(addBusinessDays(now, min)) + ' – ' + fmt.format(addBusinessDays(now, max));
      el.hidden = false;
    });
  }

  /* Sticky mobile bar: visible only once the buy box has scrolled out of view */
  function initSticky() {
    var bar = document.querySelector('[data-bv-sticky]');
    var info = document.querySelector('.product__info-container');
    var footer = document.querySelector('.footer, footer');
    if (!bar || !info || !('IntersectionObserver' in window)) return;

    var infoVisible = true;
    var footerVisible = false;
    function update() {
      var pastInfo = info.getBoundingClientRect().bottom < 0;
      var show = !infoVisible && pastInfo && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    new IntersectionObserver(function (entries) {
      infoVisible = entries[0].isIntersecting;
      update();
    }).observe(info);
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      }).observe(footer);
    }
  }

  function init() {
    renderDelivery();
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
